// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__24EAr","sendOtp":"AuthorizeToLogin_sendOtp__28G-H"};